import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
    fetchBaseQuery({
        baseUrl: getAPIURL("/api/expert"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })
);

export const expertApi = createApi({
    reducerPath: "expertApi",
    baseQuery: baseQueryWithRejection,
    tagTypes: [],
    endpoints: (builder) => ({
        getExpertName: builder.query({
            query: () => "/full-name",
            transformResponse: (response) => response.data,
            providesTags: [],
        }),
        getExperts: builder.query({
            query: ({ params }) => {
                const tmp = new URLSearchParams();
                params.country_id.forEach((element) => {
                    tmp.append("country_id", element);
                });
                params.country_of_residence.forEach((element) => {
                    tmp.append("country_of_residence", element);
                });
                params.lang_id.forEach((element) => {
                    tmp.append("lang_id", element);
                });
                params.expertise.forEach((element) => {
                    tmp.append("expertise", element);
                });
                params.expert_name.forEach((element) => {
                    tmp.append("person_id", element);
                });
                params.mission_country_id.forEach((element) => {
                    tmp.append("mission_country_id", element);
                });
                // {
                //     params.is_active &&
                //     tmp.append("is_active", 1);
                // }
                // {
                //     params.is_available &&
                //     tmp.append("is_available", 1);
                // }

                tmp.append("user_id", params.user_id);
                if (params?.select_expert_peereviewer) {
                    tmp.append("select_expert_peereviewer", params.select_expert_peereviewer);
                }
                return `/load_experts?${tmp.toString()}`;
            },
            transformResponse: (response) => response.data,
            providesTags: [],
        }),
    }),
});

export const {
    useGetExpertNameQuery,
    useGetExpertsQuery,
    useLazyGetExpertsQuery,
} = expertApi;
